// 预发布
export default {
  bucketName: 'prod-ubq',
  cdnUrl: 'https://obs.prod.ubanquan.cn',
  // 优版权obs cdn
  cdnMLMUrl: 'https://obs.prodipbank.ubanquan.cn',
  // 漫联盟obs cdn
  cdnBWLUrl: 'https://obs.prodbwl.ubanquan.cn' // obs博物联
};